var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"text-center"},[_c('h3',{staticClass:"mb-4"},[_vm._v("Página No Encontrada")]),_c('div',{staticClass:"links"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Ir a Inicio")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }